export default class RouteConstants {
  static OPTOMETRY_PENDING = {
    name: "OPTOMETRY_PENDING",
    path: "/app/optometria/consultas-pendientes",
  };
  static OPTOMETRY_HISTORY = {
    name: "OPTOMETRY_HISTORY",
    path: "/app/optometria/historial-consultas",
  };
  static AUDIOMETRY_PENDING = {
    name: "AUDIOMETRY_PENDING",
    path: "/app/audiometria/consultas-pendientes",
  };
  static AUDIOMETRY_HISTORY = {
    name: "AUDIOMETRY_HISTORY",
    path: "/app/audiometria/historial-consultas",
  };

  static DOWNLOAD_STUDIES = {
    name: "DOWNLOAD_STUDIES",
    path: "/descarga/:idStudy",
  };
  static SCREEN_TURN = {
    name: "SCREEN_TURN",
    path: "/app/turnos",
  };
  static DOCTOR = {
    name: "DOCTOR",
    path: "/app/medicos",
  };
  static IMAGE_HISTORY = {
    name: "IMAGE_HISTORY",
    path: "/app/imagen/historial",
  };

  static COLPOSCOPY_PENDING = {
    name: "COLPOSCOPY_PENDING",
    path: "/app/colposcopia/pendientes",
  };
  
  static COLPOSCOPY_HISTORY = {
    name: "COLPOSCOPY_HISTORY",
    path: "/app/colposcopia/historial",
  };

  static TELEMEDICINE_PENDING = {
    name: "TELEMEDICINE_PENDING",
    path: "/app/telemedicina/pendientes",
  };

  static TELEMEDICINE_PAGINATION_START = {
    name: "TELEMEDICINE_PAGINATION_START",
    path: "/app/telemedicina/por-iniciar",
  };

  static TELEMEDICINE_PAGINATION_HISTORY = {
    name: "TELEMEDICINE_PAGINATION_HISTORY",
    path: "/app/telemedicina/historial",
  };


}
